import React from 'react';
import PropTypes from 'prop-types';

import {translate} from 'views/module';

import CompactDropdown from 'views/scenes/client/detail/client_scenes/client_feed/header/client_details/dropdowns/CompactDropdown';

const priorityOptions = [1, 2, 3, 4];

const getPriorityLabel = (priority) => {
  if (priority === null || priority === undefined || priority === '') {
    return translate('case.List.PriorityUnprioritized');
  }

  return translate('case.List.PriorityLabel', {priority});
};

const CasePriorityDropdown = (props) => {
  const {
    label,
    selectedPriority,
    setSelectedPriority,
  } = props;

  const selectedPriorityNumber = Number(selectedPriority);
  const hasSelectedPriority = selectedPriority !== null &&
    selectedPriority !== undefined &&
    selectedPriority !== '' &&
    Number.isFinite(selectedPriorityNumber);

  const handleOptionSelect = (priority) => {
    if (hasSelectedPriority && priority === selectedPriorityNumber) {
      return;
    }

    setSelectedPriority(priority);
  };

  return (
    <CompactDropdown
      getOptionKey={(option) => option}
      getOptionLabel={getPriorityLabel}
      isOptionSelected={(option) => hasSelectedPriority && option === selectedPriorityNumber}
      label={label}
      menuLabel={label}
      onOptionSelect={handleOptionSelect}
      options={priorityOptions}
      value={getPriorityLabel(hasSelectedPriority ? selectedPriorityNumber : null)}
    />
  );
};

CasePriorityDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  selectedPriority: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setSelectedPriority: PropTypes.func.isRequired,
};

export default React.memo(CasePriorityDropdown);
